import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Xebuyttonghop from "components/Xebuyt/Xebuyttonghop.js";
export default function BCXedulichhopdong() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Báo cáo tháng xe buýt",
            tabContent: <Xebuyttonghop />,
          },
        ]}
      />
    </div>
  );
}
